<!-- Skeleton State -->
<div class="photo-grid" [ngStyle]="gridStyle" *ngIf="loading && images.length === 0">
	<div class="photo-skeleton" *ngFor="let s of skeletons">
		<div class="skeleton-pulse"></div>
	</div>
</div>

<!-- Empty State -->
<div class="gallery-empty-state" *ngIf="!loading && images.length === 0">
	<i [class]="emptyIcon"></i>
	<h4>{{ emptyTitle }}</h4>
	<p *ngIf="emptyDescription">{{ emptyDescription }}</p>
</div>

<!-- Photo Grid -->
<div class="photo-grid" [ngStyle]="gridStyle" *ngIf="images.length > 0">
	<div class="photo-thumbnail" *ngFor="let img of images; trackBy: trackByUrl" (click)="openLightbox(img)">
		<div class="skeleton-pulse" *ngIf="getImageState(img) === 'loading'"></div>
		<img [src]="img"
			 (load)="onImageLoad(img)"
			 (error)="onImageError(img)"
			 [class.loaded]="getImageState(img) === 'loaded'"
			 alt="Foto de entrega" />
		<div class="error-fallback" *ngIf="getImageState(img) === 'error'">
			<i class="fa-solid fa-image-slash"></i>
			<span>Error al cargar</span>
		</div>
		<div class="thumbnail-overlay">
			<i class="fa-solid fa-expand"></i>
		</div>
	</div>
</div>

<!-- Lightbox -->
<p-dialog [(visible)]="lightboxVisible"
		  [modal]="true"
		  [closable]="true"
		  [dismissableMask]="true"
		  [showHeader]="false"
		  styleClass="image-lightbox-dialog"
		  (onHide)="closeLightbox()">
	<div class="lightbox-container" *ngIf="selectedImage">
		<button class="lightbox-nav lightbox-prev" (click)="navigateImage(-1)" *ngIf="images.length > 1">
			<i class="fa-solid fa-chevron-left"></i>
		</button>
		<img [src]="selectedImage" alt="Foto de entrega" class="lightbox-image" />
		<button class="lightbox-nav lightbox-next" (click)="navigateImage(1)" *ngIf="images.length > 1">
			<i class="fa-solid fa-chevron-right"></i>
		</button>
		<div class="lightbox-counter" *ngIf="images.length > 1">
			{{ currentIndex + 1 }} / {{ images.length }}
		</div>
	</div>
</p-dialog>
